import React from 'react'
import PropTypes from 'prop-types'

import { BodyScrollLock } from '../../styled'
import {
  ModalBackdrop,
  ModalDialog
} from './styles'

const Modal = ({
  children,
  dataTest,
  visible,
  onClose
}) => {
  return (
    <>
      <ModalBackdrop visible={visible} onClick={onClose} data-test={`${dataTest}-modal-backdrop`} />
      <ModalDialog visible={visible} data-test={`${dataTest}-modal-dialog`}>
        {children}
      </ModalDialog>
      <BodyScrollLock active={visible} />
    </>
  )
}

export default Modal

Modal.propTypes = {
  onClose: PropTypes.func,
  children: PropTypes.node,
  dataTest: PropTypes.string,
  visible: PropTypes.bool
}
